module.exports = __webpack_public_path__ + "img/txt-sneaker-legacy.72a69a3d.png";